<div *ngIf="bannerType > 0 && !isHqUser" class="custom-banner">
  <div class="image-container">
    <!-- Left Image -->
    <img [src]="images?.WARNING_BANNER_IMG" class="banner-image" alt="subscription" />
  </div>
  <div class="text-container">
    <div class="banner-text1 fs-20 fw-600">
      {{ (bannerType === 1 ? 'NOT_USE' : 'WARNING') | fallbackTranslate }}
    </div>
    <div class="banner-text2 fs-16 fw-400">
      {{ renewYourSub }} {{ 'COMMON_STR' | fallbackTranslate }}
    </div>
  </div>
  <button class="renewal-button fw-600 fs-16" (click)="renew()">
    {{ (!isNegative ? 'RENEW_NOW' : 'NUDGE.PAY_NOW_BUTTON_TEXT') | fallbackTranslate }}
  </button>
</div>
